import { useState, useEffect } from 'react';
import api from '../services/api';

let cached = null; // module-level cache — one fetch per page load

export function useAmoebaConfig() {
    const [config, setConfig] = useState(cached || {
        orgName: 'JA Technology Labs',
        orgLogoUrl: '',
        enabledAmoebas: 'ALL',
        baseCurrency: 'INR',
        primaryAuthMethod: 'MANUAL',
        googleAuthConfigured: false,
        microsoftAuthConfigured: false,
        samlAuthConfigured: false,
        baseDomain: 'junkyardamoeba.com',
    });
    const [loading, setLoading] = useState(!cached);

    useEffect(() => {
        if (cached) return;
        api.get('/auth/config')
            .then(r => { cached = r.data; setConfig(r.data); })
            .catch(err => console.error('Failed to fetch tenant config', err))
            .finally(() => setLoading(false));
    }, []);

    const hasAmoeba = (name) => {
        const enabled = config.enabledAmoebas || 'ALL';
        if (enabled === 'ALL') return true;
        return enabled.split(',').map(a => a.trim().toUpperCase()).includes(name.toUpperCase());
    };

    return { config, loading, hasAmoeba };
}
